import Cookies from 'js-cookie';

const backendHost = Cookies.get('backendHost');

// eslint-disable-next-line max-len
const BaseApi = backendHost ? backendHost : (window.location.href.startsWith('https://grc.ua') || window.location.href.startsWith('https://www.grc.ua')) ? 'https://grc.ua/api' : window.location.href.startsWith('https://test19742.grc.ua/') ? 'https://test19742.grc.ua/api' : process.env.REACT_APP_API_URL;

export default BaseApi;
